module.exports = __webpack_public_path__ + "static/media/8.58dbd857.JPG";